<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-badge
        class="font-weight-bold"
        :content="file_count"
        :value="file_count"
        color="amber darken-4"
        overlap
        bordered
        left
        offset-x="20"
        offset-y="9"
      >
        <v-btn
          v-on="on"
          x-small
          icon
          color="primary"
          class="mx-3"
          @click="onOpenShipmentFileCabinet"
        >
          <v-icon size="20">mdi-file-multiple</v-icon>
        </v-btn>
      </v-badge>
    </template>
    Shipment files
  </v-tooltip>
</template>

<script>
import constant from "../../const";
import "firebase/firestore";
export default {
  props: ["shipment_order_id", "company_id"],
  data() {
    return {
      file_count: 0,
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getFileCount();
  },
  methods: {
    /**
     * Get the Real Time file count
     */
    getFileCount() {
      // set the comment messages for each quotation
      const firestore_db = this.$root.messageCenterApp.firestore();
      // Get the message count and listen to the document
      firestore_db
        .collection("af-files")
        .doc(this.company_id)
        .collection("shipments")
        .doc(this.shipment_order_id)
        .onSnapshot((doc) => {
          if (!doc.exists) {
            this.file_count = 0;
          } else {
            // get the file count number
            this.file_count = doc.data().file_count;
          }
        });
    },
    /**
     * on open shipment file cabinet
     */
    onOpenShipmentFileCabinet() {
      //   this.selectedShipmentId = this.shipment.shipment_order_id;
      //   this.selectedCompanyId = this.shipment.company_id;
      this.$emit("open-shipment-file-dialog", this.shipment_order_id, this.company_id);
    },
  },
  computed: {},
};
</script>

<style scoped></style>
